import { motion } from "framer-motion";



export default function JumpingLetters({ text, isHover }) {
    const characters = text.split("");
    const length = text.length;
    
    
    return (
        <div style={{whiteSpace: "normal", wordBreak: "normal"}}>

          
                {characters.map((character, i) => (
                    <motion.span
                        initial={{
                            y: 0
                        }}
                        animate={
                            isHover ? {y: [0, -15, 0]} : {y: 0}
                        }
                        transition={
                            isHover 
                            ? {
                                duration: 0.3,
                                delay: i/12,
                                repeat: Infinity,
                                repeatDelay: 0.15*length,
                                
                            } 
                            : { duration: 0.3 }
                            
                        }
                        key={i}
                        style={{ 
                            display: "inline-block", 
                            fontFamily: "Karantina",
                            fontSize: "100px",
                            letterSpacing: "5px"
                        }}
                    
                    >
                        {character}
                    </motion.span>
                ))}
        </div> 
    );
}

